// extracted by mini-css-extract-plugin
export default {"iconRoot":"Icon_iconRoot__zT3RM","iconSmall":"Icon_iconSmall__Oq5Jz","iconMedium":"Icon_iconMedium__U44hK"};